import React from 'react';
import {AbsoluteCenter, Box, Flex, useTheme} from '@chakra-ui/react';
import {
  TextG10,
  TextG12,
  TextG14,
  TextG16,
  TextG20,
} from '../../components/typography';
import {numberToCurrency} from '../../utils/price';
import {getMembershipColor} from '../../utils/membership';
import useAuth from '../../hooks/useAuth';
import {MembershipPlan} from "../../endpoints/interfaces/membershipPlan";

interface MembershipHeaderCardProps {
  membership: MembershipPlan;
  selectedMembershipId: number | undefined;
  setSelectedMembershipId: (id: number | undefined) => void;
  isAnnualPaymentSelected: boolean;
  setIsAnnualPaymentSelected: (isAnnual: boolean) => void;
}

const isSelectedMembership = (membership: MembershipPlan, selectedId: number | undefined, isAnnualSelected = false) => {
  if(isAnnualSelected) {
    return membership.id === selectedId && membership.annual;
  }

  return membership.id === selectedId && !membership?.annual;
}

const MembershipHeaderCard = ({
  membership,
  selectedMembershipId,
  setSelectedMembershipId,
  isAnnualPaymentSelected,
  setIsAnnualPaymentSelected,
}: MembershipHeaderCardProps) => {
  const {user} = useAuth();
  const theme = useTheme();

  if (!membership) return null;

  const isSelected = isSelectedMembership(membership, selectedMembershipId, isAnnualPaymentSelected);

  const isCurrentMembership = user?.activeMembershipPlan?.id == membership.id;

  return (
    <Flex
      position="relative"
      maxWidth="160px"
      zIndex={isSelected ? 99 : 1}
      transition="all 0.3s ease"
      onClick={() => {
        setSelectedMembershipId(membership.id);
        setIsAnnualPaymentSelected(membership?.annual || false);
      }}
      outline={isSelected ? `2px solid ${getMembershipColor(membership)}` : '2px solid lightgrey'}
      borderRadius="18px"
      flexDir="column"
      px={4}
      py={4}
      background={!isSelected ? 'white' : membership.id == 1 ? '#F4FFFD' : '#F8F5FE'}
      boxShadow={isSelected ? '0px 4px 30px 0px #00000033' : ''}
      color={isSelected ? theme.colors.lightBlack : theme.colors.grey}>
      {isCurrentMembership && (
        <AbsoluteCenter w="fit-content" top="0" whiteSpace="nowrap">
          <TextG10
            transition="all 0.3s ease;"
            textAlign="center"
            borderRadius="5px"
            px="7px"
            py="5px"
            fontWeight="500"
            background={isSelected ? getMembershipColor(membership) : 'lightgrey'}
            color="white">
            Current Membership
          </TextG10>
        </AbsoluteCenter>
      )}
      <Flex alignItems="flex-start" flexDir="column">
        <TextG14 fontWeight="700">{membership.card_name}</TextG14>
      </Flex>
      {membership?.annual ? (
        <>
          <Flex mt="10px" alignItems="baseline">
            <TextG20 fontWeight="700">{numberToCurrency(membership.monthly_cost * 11)}</TextG20>
            <TextG16 fontWeight="700">/yr</TextG16>
          </Flex>
          <TextG12 fontWeight="500" mt="2px" color={theme.colors.grey}>{`You save ${numberToCurrency(membership.monthly_cost)}`}</TextG12>
          </>
        ) : (
        <>
          <Flex mt="10px" alignItems="baseline">
            <TextG20 fontWeight="700">{numberToCurrency(membership.monthly_cost)}</TextG20>
            <TextG16 fontWeight="700">/mo</TextG16>
          </Flex>
          <TextG12 fontWeight="500" mt="2px" color={theme.colors.grey}>{`${numberToCurrency(
        membership.monthly_benefit_value
          )}+ Value`}</TextG12>
        </>
      )}


      <Box mt="12px" color={isSelected ? '#374957' : theme.colors.grey} fontWeight="500">
        {/* {membership.id == 1 ? (
          <>
            <TextG9 fontWeight="500">
              All the essentials needed to get fully plugged into your neighborhood.
            </TextG9>
          </>
        ) : (
          <>
            <TextG9 fontWeight="500">
              Insider access to the best your neighborhood has to offer.
            </TextG9>
          </>
        )} */}
      </Box>
    </Flex>
  );
};

export default MembershipHeaderCard;
